import { render, staticRenderFns } from "./TestingOrganizationCreate.vue?vue&type=template&id=af8935fe&scoped=true&"
import script from "./TestingOrganizationCreate.vue?vue&type=script&lang=ts&"
export * from "./TestingOrganizationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8935fe",
  null
  
)

export default component.exports